import RichText from '~/components/RichText/RichText'
import { resolveProductPriceDisplay } from '~/helpers'
import { usePage } from '~/hooks'
import { ResolvedCustomerType, Product } from '~/types'
import { ProductDashboardPrice } from './ProductDashboardPrice'
import styles from './ProductDashboardPricing.module.scss'

export interface ProductDashboardPricingProps {
  product: Product
  resolvedCustomerType?: ResolvedCustomerType
}

export const ProductDashboardPricing = ({
  product,
  resolvedCustomerType,
}: ProductDashboardPricingProps) => {
  const {
    finalPrice,
    memberPrice,
    regularPrice,
    hasPromoDiscount,
    hasCustomerTypeDiscount,
  } = product ?? {}

  // Guests and Standard customers are shown the member price as an incentive unless the
  // product is on promo. Everyone else keeps the price they are entitled to.
  const display = resolveProductPriceDisplay({
    finalPrice,
    regularPrice,
    memberPrice,
    hasPromoDiscount,
    hasCustomerTypeDiscount,
    resolvedCustomerType,
  })
  const { isGuestWithMemberPrice, isStandardWithMemberPrice } = display
  const { membershipCallToAction, membershipUpgradeCallToAction } = usePage()

  return (
    <div className={styles.container}>
      <ProductDashboardPrice
        finalPrice={display.finalPrice}
        regularPrice={regularPrice}
        hasPromoDiscount={display.hasPromoDiscount}
        hasCustomerTypeDiscount={display.hasCustomerTypeDiscount}
        resolvedCustomerType={display.resolvedCustomerType}
      />

      {isGuestWithMemberPrice && membershipCallToAction?.json && (
        <div className={styles.memberPrompt}>
          <RichText content={membershipCallToAction.json} />
        </div>
      )}

      {isStandardWithMemberPrice && membershipUpgradeCallToAction?.json && (
        <div className={styles.memberPrompt}>
          <RichText content={membershipUpgradeCallToAction.json} />
        </div>
      )}
    </div>
  )
}
